var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_464_23551",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_464_23551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.375C11.7833 21.375 11.5627 21.3293 11.338 21.238C11.1127 21.146 10.9083 21.0083 10.725 20.825L3.175 13.275C2.99167 13.0917 2.85433 12.8917 2.763 12.675C2.671 12.4583 2.625 12.2333 2.625 12C2.625 11.7833 2.671 11.5623 2.763 11.337C2.85433 11.1123 2.99167 10.9083 3.175 10.725L10.725 3.175C10.9083 2.99167 11.1083 2.854 11.325 2.762C11.5417 2.67067 11.7667 2.625 12 2.625C12.2167 2.625 12.4377 2.67067 12.663 2.762C12.8877 2.854 13.0917 2.99167 13.275 3.175L20.825 10.725C21.0083 10.9083 21.146 11.1083 21.238 11.325C21.3293 11.5417 21.375 11.7667 21.375 12C21.375 12.2167 21.3293 12.4373 21.238 12.662C21.146 12.8873 21.0083 13.0917 20.825 13.275L13.275 20.825C13.0917 21.0083 12.8917 21.146 12.675 21.238C12.4583 21.3293 12.2333 21.375 12 21.375ZM12 16.65L16.65 12L12 7.35L10.95 8.4L13.775 11.25H7.35V12.75H13.775L10.95 15.6L12 16.65Z",
    fill: "#414141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionsAlt);
export default __webpack_public_path__ + "static/media/directions_alt.9d0dd18e856ba010df64ee6b3dd93639.svg";
export { ForwardRef as ReactComponent };